import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

const sections = [
    {
        title: "1. Scope of Services",
        body: "Grow With Babur (\"GWB\") provides personal branding, marketing strategy, content creation, social media management and lead generation services as described in the selected package. Deliverables, quantities and timelines are as outlined in the specific package purchased.",
    },
    {
        title: "2. Payment Terms",
        body: "All payments are due upfront and in full before work commences. We accept card payments via Stripe. Partial or installment payments are not offered by default. Payments are non-refundable once work has commenced.",
    },
    {
        title: "3. Not Included in Packages",
        body: "Advertising / boost budget (Meta Ads, Google Ads, TikTok Ads spend), domain purchases, hosting fees, third-party subscriptions (design tools, scheduling tools), and paid photography permits are NOT included in any package unless explicitly stated in writing.",
    },
    {
        title: "4. Content Delivery & Revisions",
        body: "Standard reel editing turnaround is 48 hours from shoot day. Each reel includes up to two (2) rounds of revisions. Revisions requested beyond this may be billed hourly. Final files are delivered via Google Drive or WeTransfer.",
    },
    {
        title: "5. Shoot Scheduling",
        body: "After payment, the client will be granted access to Babur's calendar to book shoot slots. Reschedules must be made at least 48 hours in advance. Same-day cancellations may incur a 50% shoot fee.",
    },
    {
        title: "6. Intellectual Property & Usage Rights",
        body: "Upon full payment, the client receives an unlimited, perpetual license to use all delivered content across their personal and business social media and marketing channels. GWB retains the right to feature delivered work in its own portfolio, case studies and marketing.",
    },
    {
        title: "7. Confidentiality",
        body: "Both parties agree to keep confidential any non-public business information shared during the engagement. This clause survives the termination of the agreement.",
    },
    {
        title: "8. Termination",
        body: "Either party may terminate the engagement in writing with 14 days' notice. Fees for services rendered up to the termination date are non-refundable. Any unused deliverables at time of termination are forfeited.",
    },
    {
        title: "9. Limitation of Liability",
        body: "GWB is a service provider and does not guarantee specific follower counts, lead volumes, sales or revenue outcomes. Client success depends on many factors outside of GWB's control (market conditions, product quality, client responsiveness). GWB's total liability shall not exceed the fees paid by the client for the specific package in question.",
    },
    {
        title: "10. Governing Law",
        body: "This agreement is governed by the laws of the United Arab Emirates. Any disputes shall be resolved amicably where possible, and failing that, in the courts of Dubai, UAE.",
    },
    {
        title: "11. Contact",
        body: "Questions about these terms? Email baburali514@gmail.com or WhatsApp +971 54 367 6278.",
    },
];

export default function Terms() {
    return (
        <div>
            <Navbar />
            <main className="pt-32 sm:pt-40 pb-24 max-w-4xl mx-auto px-5 sm:px-8">
                <Link to="/" className="inline-flex items-center gap-2 text-sm text-white/60 hover:text-brand transition-colors mb-8 font-mono uppercase tracking-widest">
                    <ArrowLeft className="w-4 h-4" /> Back to home
                </Link>
                <div className="eyebrow mb-4">Legal</div>
                <h1 className="font-display font-medium tracking-[-0.04em] text-5xl sm:text-6xl lg:text-7xl text-white leading-[1.02]">
                    Terms &amp;<br />Conditions
                </h1>
                <p className="mt-6 text-white/50 text-sm font-mono">Last updated: February 2026</p>

                <div className="mt-16 space-y-10">
                    {sections.map((s) => (
                        <div key={s.title} className="border-l-2 border-brand/30 pl-6">
                            <h2 className="font-display font-semibold text-2xl text-white tracking-[-0.02em]">{s.title}</h2>
                            <p className="mt-3 text-white/70 leading-relaxed">{s.body}</p>
                        </div>
                    ))}
                </div>
            </main>
            <Footer />
        </div>
    );
}
